import React, { useState } from "react";
import CardStatsDetalleDrop from "../../components/Cards/CardStatsDetalleDrop.js";
import CardStats from "../../components/Cards/CardStats.js";
import DetalleRecepcionModal from "../../components/DetalleRecepcionModal/DetalleRecepcionModal.jsx";

export default function HeaderStatsDrop({ entregasT, selectedDate, selectedDateEnd }) {
  const [showRecepcionModal, setShowRecepcionModal] = useState(false);
  const KG_PER_BOLSA = 5;
  const totalCompost = entregasT * KG_PER_BOLSA;

  return (
    <>
      <div className="relative bg-lightBlue-600 md:pt-10 pb-32 pt-10">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div className="flex flex-wrap">
            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStatsDetalleDrop
                statSubtitle="Bolsas Recolectadas"
                statTitle={entregasT}
                statIconName="fas fa-fan"
                statIconColor="bg-green-300"
                handleDetail={() => setShowRecepcionModal(true)}
              />
            </div>
            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStats
                statSubtitle="Compost estimado (kg)"
                statTitle={totalCompost}
                statIconName="fas fa-seedling"
                statIconColor="bg-green-200"
              />
            </div>
          </div>
        </div>
      </div>

      {showRecepcionModal && (
        <DetalleRecepcionModal
          onClose={() => setShowRecepcionModal(false)}
          desde={selectedDate}
          hasta={selectedDateEnd}
        />
      )}
    </>
  );
}
